export const CHANNEL_LIST_FILTER = "1575";
export const EPG_CACHE_HOURS = 12;
export const UPDATE_FEATURED_MS = 120000;
